import { useMutation, useQueryClient } from '@tanstack/react-query';

import principalsAPI from 'api/principalsAPI';
import { CandidateActionStatus } from 'features/Principal/types/candidatesListTypes';
import { principalCandidatesListQueries } from 'queryKeys/principal';

interface UseUpdateCandidateStageMutationOptions {
  onSuccess?: (data: unknown, variables: CandidateActionStatus, context: unknown) => void;
}

export const useUpdateCandidateStageMutation = (
  applicationId: number,
  options: UseUpdateCandidateStageMutationOptions = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (stage: CandidateActionStatus) =>
      principalsAPI.updateCandidateStage(applicationId, stage),
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: principalCandidatesListQueries.list._def,
      });

      options.onSuccess?.(data, variables, context);
    },
  });
};
